<template>
  <el-cascader
    v-if="loaded"
    style="width: 100%"
    size="mini"
    :placeholder="placeholder"
    :clearable="clearable"
    :show-all-levels="showAllLevels"
    :props="cascaderProps"
    v-model="selfList"
    @change="updateList"
  />
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    url: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    showAllLevels: {
      type: Boolean,
      default: true
    },
    checkStrictly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let self = this
    return {
      loaded: false,
      selfList: [],
      cascaderProps: {
        checkStrictly: this.checkStrictly, // 是否取消关联
        lazy: true, // 动态加载
        lazyLoad(node, resolve) {
          let { value } = node
          let nodes = [] // 动态节点
          let id = value || 0 // 0 获取一级列表
          self.getCategoryListData(id).then((res) => {
            res.forEach((item) => {
              let obj = {
                value: item.id,
                label: item.name,
                leaf: !item.has_children,
                disabled: item.status === false
              }
              nodes.push(obj)
            })
            resolve(nodes) // 回调
          })
        }
      }
    }
  },
  watch: {
    list: {
      handler(val) {
        this.loaded = false
        this.selfList = this.$util.deepCopy(val)
        this.loaded = true
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取各层级分类列表数据
    async getCategoryListData(id) {
      let list = []
      let data = {
        currentPage: 1,
        pageSize: this.$constant.pageMax,
        filterData: {},
        sortData: { id: 'asc' }
      }
      if (id) {
        if (this.url === '/admin/gcvip/columnData/list') {
          data.id = id
        } else {
          data.filterData.parent_id = id
        }
      }
      await this.$api({
        method: 'post',
        url: this.url,
        data
      }).then((res) => {
        list = res.data.page ? res.data.page.list : res.data.list
      })
      return list
    },
    updateList(val) {
      let result = this.$util.deepCopy(val)
      this.$emit('update:list', result)
    }
  }
}
</script>

<style lang="less" scoped></style>
